// @flow

/**
 * This Component is Renderd in primary position in trekOverview.
 * It renders different buttons based on props.
 */

import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  searchFlights,
  storeNoFlights,
} from '../../../redux/actions/trekPaymentReviewActions';
import withTrekPermission from '../../../HOCs/withTrekPermission';

type Props = {
  isTemplate: boolean,
  isFrozen: boolean,
  isOwner: boolean,
  isFollower: boolean,
  isGuided: boolean,
  location: { pathname: string, search: string },
  searchFlights: () => void,
  location: Object,
  userHasEnteredStartDatee: string,
  trekAlreadyHasStartDate: string,
  history: {
    push: (url: string) => void,
  },
  wantTrekDateError: () => void,
  isFlightsAvailable: boolean,
  handleAfterError: () => void,
  trekHasNoFlights: boolean,
};

class PrimaryCTA extends Component<Props> {
  static defaultProps = {
    handleAfterError: () => {},
  };

  handleClick = () => {
    const {
      searchFlights,
      isGuided,
      location,
      history,
      wantTrekDateError,
      handleAfterError,
      userHasEnteredStartDate,
      trekAlreadyHasStartDate,
      trekHasNoFlights,
    } = this.props;

    let url = location.pathname + '/review';

    if (isGuided) {
      url = url + '-guided-trek';
      history.push(url);
    } else {
      if (trekHasNoFlights) {
        history.push(url);

        return;
      }

      if (userHasEnteredStartDate || trekAlreadyHasStartDate) {
        searchFlights(() => {
          history.push(url);
        });
      } else {
        handleAfterError();
        wantTrekDateError();
      }
    }
  };

  render() {
    return (
      <div id="primaryCTA">
        <a className="btn btn-yellow" href="https://wa.me/9779801916215" target="_blank" rel="noopener noreferrer">
          <img src="https://honeyguide.s3.amazonaws.com/assets/icons/whatsapp.png" height="16" alt=""/> TALK TO HONEYGUIDE
        </a>
      </div>
    );
  }
}

const mapStateToProps = ({
  trekPayment: {
    trekTemplateStartDate,
    isFlightsAvailable,
    isLoading,
    userIsPickingDatesOrPax,
    flights,
  },
  selectedTrek: {
    trek: { start_date },
  },
}) => ({
  isFlightsAvailable,
  isLoading,
  userIsPickingDatesOrPax,
  userHasEnteredStartDate: Boolean(trekTemplateStartDate),
  trekAlreadyHasStartDate: Boolean(start_date),
  trekHasNoFlights: isEmpty(flights),
});

const mapDispatchToProps = dispatch => ({
  searchFlights: (onSuccess, onFailure) => dispatch(searchFlights(onSuccess, onFailure)),
  wantTrekDateError: () => dispatch(storeNoFlights()),
});

export default withRouter(
  withTrekPermission(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(PrimaryCTA)
  )
);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/DayOverview/PrimaryCTA.jsx